var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-main"},[_c('banner'),_c('service'),_c('card'),_c('report',{attrs:{"prev-route":_vm.prevRoute}}),_c('fonts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }